// @flow

import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';

import TextBlock from '../TextBlock';

import './MobileDeviceNotice.scss';

const messages = defineMessages({
  mobileDeviceNotice: {
    id: 'docsApp.stripeShell.mobileDeviceNotice',
    description:
      'A message that will be rendered when the Stripe Shell is opened on a mobile device',
    defaultMessage: 'The Stripe Shell is best experienced on desktop.',
  },
});

const MobileDeviceNotice = (): React.Node => {
  const {formatMessage} = useIntl();

  return (
    <div className="MobileDeviceNotice__container">
      <TextBlock>{formatMessage(messages.mobileDeviceNotice)}</TextBlock>
    </div>
  );
};

export default MobileDeviceNotice;
